import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css'],
    standalone: false
})

export class LoadingComponent implements OnInit {

  @Input() showLoading = false; // Default is false;
  @Input() loadingMessage = 'Some default text. Need to check why message is not provided'; // Default is 'Connecting...'

  constructor() { }

  ngOnInit() { }
}
